import { DashboardLayout } from "components/DashboardLayout";
import { SOURCE, VENDOR_TYPE } from "constants/vendor";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useCurrentGroupContext } from "hooks/useCurrentGroupContext";
import { UpdateMultipleFilterFunction, useFilters } from "hooks/useFilter";
import { VendorRequest } from "store/apis/vendors";
import { VendorHeader } from "../BillsAndVendors/VendorHeader";
import { VendorsContent } from "../BillsAndVendors/VendorsContent";

export type VendorFilterType = {
  SEARCH_TERM: string | null;
  SEASON: string | null;
  SOURCE: keyof typeof SOURCE | null;
  VENDOR_TYPE: keyof typeof VENDOR_TYPE | null;
  SHOW_ESTIMATED_1099: boolean;
  RELATED_PARTY: boolean;
  PAGE_NUM: number;
};

export type VendorFilterProps = {
  filter: VendorFilterType;
  updateFilter: (
    key: keyof VendorFilterType,
    value: VendorFilterType[keyof VendorFilterType]
  ) => void;
  updateMultipleFilters?: UpdateMultipleFilterFunction<VendorFilterType>;
};

export const Vendors = () => {
  const { uuid: groupId } = useCurrentGroupContext();
  const entityId = useCurrentEntityId();

  const { values, updateFilter, updateMultipleFilters } =
    useFilters<VendorFilterType>({
      initialValue: {
        SEARCH_TERM: null,
        SEASON: null,
        SOURCE: null,
        VENDOR_TYPE: null,
        SHOW_ESTIMATED_1099: false,
        RELATED_PARTY: false,
        PAGE_NUM: 1,
      },
      useQueryParams: true,
    });

  const queries: VendorRequest = {
    groupId: groupId,
    page_num: values.PAGE_NUM,
    type: values.VENDOR_TYPE,
    search_term: values.SEARCH_TERM,
    season: values.SEASON,
    merchant_source: values.SOURCE,
    entityId,
    refresh_merchants: true,
  };

  return (
    <DashboardLayout
      header={
        <VendorHeader
          entityId={entityId}
          groupId={groupId}
          vendorQuery={queries}
        />
      }
    >
      <VendorsContent
        entityId={entityId}
        groupId={groupId}
        filter={values}
        updateFilter={updateFilter}
        updateMultipleFilters={updateMultipleFilters}
      />
    </DashboardLayout>
  );
};
